<div class="wrapper">

    <app-header *ngIf="fengIntegration == false && hideHeaderFooter == false" [showFilter]="showFilter"></app-header>

    <div  [ngClass]="{'content-page': fengIntegration == false}">
        <router-outlet></router-outlet>
    </div>
    <app-cookie-message></app-cookie-message>
    <app-footer  *ngIf="fengIntegration == false && hideHeaderFooter == false"></app-footer>

    <!-- <div *ngIf="fengIntegration == true" class="d-flex justify-content-center mb-3 mt-5 aling-items-center">
        <img width="211px" src="../../../../assets/images/logo.png">
    </div> -->
</div>
